/**
 * TransitRow — single transit listing row with aspect-colored glyph icon.
 * Verbatim port of mobile.html `.transit-row` (icon glyph + title + time + arrow).
 */
import type { ReactElement } from "react";

import { hapticImpact } from "@/lib/tg";

export type AspectKind = "trine" | "sextile" | "square" | "opposition" | "conjunction";

export interface TransitRowProps {
  readonly glyph: string;
  readonly title: string;
  readonly time: string;
  readonly aspect: AspectKind;
  readonly onPress?: () => void;
}

function aspectClass(aspect: AspectKind): string {
  if (aspect === "square" || aspect === "opposition") return "square";
  if (aspect === "sextile") return "sextile";
  return "";
}

export function TransitRow({ glyph, title, time, aspect, onPress }: TransitRowProps): ReactElement {
  return (
    <button
      type="button"
      className="transit-row"
      onClick={() => {
        hapticImpact("light");
        onPress?.();
      }}
    >
      <span className={`t-icon ${aspectClass(aspect)}`} aria-hidden="true">
        {glyph}
      </span>
      <div className="info">
        <div className="t">{title}</div>
        <div className="s">{time}</div>
      </div>
      <span className="arrow" aria-hidden="true">
        ›
      </span>
    </button>
  );
}
